/**
 * Ein Titel wird nicht zweimal gelesen. (10.09.2026)
 *
 * Martin, mit Foto des „Fund des Tages": *„Erstens einmal wird die Überschrift
 * doppelt gelesen."*
 *
 * Der Fund kommt vom Modell als Markdown, und dessen erste Zeile IST der
 * Titel:
 *
 *     titel: "Vier Stillen, eine davon gelingt"
 *     text:  "# Vier Stillen, eine davon gelingt\n\nDu hast einmal gesagt …"
 *
 * Das Blatt stellte den Titel trotzdem noch einmal voran — also stand er
 * zweimal im Vorlesetext, und genau so klang es auch.
 *
 * ⚠️ Den Titel einfach wegzulassen wäre falsch: Es gibt Texte, die NICHT mit
 *    ihrer Überschrift beginnen (eine Notiz, ein Absatz aus der Mitte). Dann
 *    fehlte die Ansage. Deshalb wird nachgesehen, statt geraten.
 */

/** Wörter, auf die es beim Vergleich ankommt — ohne Zeichen und Groß/klein. */
function kern(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim();
}

/**
 * Beginnt der Text bereits mit seinem eigenen Titel?
 *
 * Geprüft wird nur die ERSTE nicht-leere Zeile: Markdown-Überschrift (`#…`),
 * fett gesetzte Alleinzeile (`**…**`) oder eine schlichte Titelzeile.
 */
export function textBeginntMitTitel(titel: string, text: string): boolean {
  const t = kern(titel);
  if (!t) return false;
  const erste = (text || "")
    .split(/\r?\n/)
    .map((z) => z.trim())
    .find((z) => z.length > 0);
  if (!erste) return false;
  const ohneMarkierung = erste
    .replace(/^#{1,6}\s*/, "")
    .replace(/^\*{1,3}|\*{1,3}$/g, "")
    .trim();
  const e = kern(ohneMarkierung);
  if (!e) return false;
  // Genau derselbe Titel — oder eine Zeile, die mit ihm beginnt und kaum
  // mehr enthält (ein Doppelpunkt-Zusatz zählt noch als derselbe Titel).
  if (e === t) return true;
  return e.startsWith(t) && e.length <= t.length + 12;
}

/**
 * Der Vorlesetext: Titel voran — aber nur, wenn er nicht schon dasteht.
 */
export function vorleseText(titel: string, text: string): string {
  const rumpf = (text || "").trim();
  const kopf = (titel || "").trim();
  if (!kopf) return rumpf;
  if (!rumpf) return kopf;
  if (textBeginntMitTitel(kopf, rumpf)) return rumpf;
  return `${kopf}.\n\n${rumpf}`;
}
